(function() {
    'use strict';
    
    const $body = document.body;
    
    // Helper to access halo functions
    function getHalo() {
        return window.halo || {};
    }
    
    const notifyInStock = {
        initNotifyInStock: function () {
            document.addEventListener('click', (event) => {
                const openBtn = event.target.closest('[data-open-notify-popup]');
                if (openBtn) {
                event.preventDefault();
                event.stopPropagation();
                    const halo = getHalo();
                    if (halo.notifyInStockPopup) {
                        halo.notifyInStockPopup(openBtn);
                    }
                }
            });

            document.addEventListener('click', (event) => {
                const closeBtn = event.target.closest('[data-close-notify-popup]');
                if (closeBtn) {
                event.preventDefault();
                event.stopPropagation();

                    $body.classList.remove('notify-me-show');
                setTimeout(() => {
                        document.querySelectorAll('.halo-notify-popup .form-field').forEach(el => {
                            el.classList.remove('hidden');
                        });
                        document.querySelectorAll('.halo-notify-popup .form-message').forEach(el => {
                            el.classList.add('hidden');
                        });
                    }, 700);
                }
            });

            document.addEventListener('click', (event) => {
                if ($body.classList.contains('notify-me-show')) {
                    const openBtn = event.target.closest('[data-open-notify-popup]');
                    const notifyPopup = event.target.closest('[data-notify-popup]');
                    if (!openBtn && !notifyPopup) {
                        $body.classList.remove('notify-me-show');
                        setTimeout(() => {
                            document.querySelectorAll('.halo-notify-popup .form-field').forEach(el => {
                                el.classList.remove('hidden');
                            });
                            document.querySelectorAll('.halo-notify-popup .form-message').forEach(el => {
                                el.classList.add('hidden');
                            });
                        }, 700);
                    }
                }
            });
        },

        notifyInStockPopup: function ($target) {
            const targetEl = $target instanceof Element ? $target : ($target && $target[0] ? $target[0] : $target);
            if (!targetEl) return;
            
            var variant,
                product = targetEl.closest('.product-item');
            if (!product) return;
            
            const cardTitle = product.querySelector('.card-title');
            const title = cardTitle ? cardTitle.dataset.productTitle : '';
            const productUrl = cardTitle ? cardTitle.dataset.productUrl : '';
            const link = window.location.host + productUrl;
            const popup = document.querySelector('[data-notify-popup]');
            if (!popup) return;

            if (targetEl.classList.contains('is-notify-me')) {
                const activeSwatch = product.querySelector('.card-swatch .swatch-label.is-active');
                variant = activeSwatch ? activeSwatch.getAttribute('title') : null;
            } else {
                variant = targetEl.dataset.variantId;
            }

            const titleInput = popup.querySelector('.halo-notify-product-title');
            const linkInput = popup.querySelector('.halo-notify-product-link');
            if (titleInput) titleInput.value = title.trim();
            if (linkInput) linkInput.value = link;

            if (variant) {
                const variantInput = popup.querySelector('.halo-notify-product-variant');
                if (variantInput) variantInput.value = variant;
            }
            $body.classList.add('notify-me-show');
        }
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all notify in stock functions to halo
    Object.assign(window.halo, notifyInStock);
    
    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            notifyInStock.initNotifyInStock();
        });
    } else {
        notifyInStock.initNotifyInStock();
    }
})();









